module.exports = __webpack_public_path__ + "img/light-mode-desktop.448398ec.svg";